import {
  colors,
  ImpContainer,
  ImpFlex,
  ImpSurface,
} from '@imprint-payments/imprint-ui';
import { useEffect } from 'react';

import { setProveSessionId } from '../../app/applicationScreenSlice';
import { useImpState } from '../../app/hooks';
import AccountStatusPage from '../../pages/accountStatusPage/AccountStatusPage';
import LetsGetStarted from './LetsGetStarted';
import PreSignupVerification from './PreSignupVerification';
import { PrefillStep, useProveContext } from './ProveContext';

interface PrefillFlowProps {
  nextStep: () => void;
}

export default function PrefillFlow({
  nextStep: goToManualApp,
}: PrefillFlowProps) {
  const { dispatch, appScreenState } = useImpState();

  const { step, setStep } = useProveContext();

  // this fucking sucks
  useEffect(() => {
    if (appScreenState.showWelcomeBackCard) {
      goToManualApp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appScreenState.showWelcomeBackCard]);

  useEffect(() => {
    if (appScreenState.showPreSignupStatus) {
      setStep(PrefillStep.AccountStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appScreenState.showPreSignupStatus]);

  useEffect(() => {
    dispatch(setProveSessionId(generateSessionId()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ImpFlex fluid justify="center">
      <ImpContainer maxWidth="368px" width="100%">
        <ImpSurface surfaceColor={colors.surface.surfaceLow}>
          {
            {
              [PrefillStep.LetsGetStarted]: <LetsGetStarted />,
              [PrefillStep.Verification]: (
                <PreSignupVerification
                  goToAccountStatus={() => setStep(PrefillStep.AccountStatus)}
                  goToManualApp={goToManualApp}
                />
              ),
              [PrefillStep.AccountStatus]: <AccountStatusPage />,
            }[step]
          }
        </ImpSurface>
      </ImpContainer>
    </ImpFlex>
  );
}

/**
 * Generates a random 6 alphanumeric character string for use as a session ID.
 * @returns {string} A randomly generated 6 character string.
 */
function generateSessionId(): string {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let sessionId = '';
  for (let i = 0; i < 6; i++) {
    sessionId += characters.charAt(
      Math.floor(Math.random() * characters.length)
    );
  }
  return sessionId;
}
